import React from 'react';

export const uangDiragukanConfig = [
  {
    path: '/penanganan-uang-diragukan',
    component: React.lazy(() => import('./listing/listing')),
  },
  {
    path: '/penanganan-uang-diragukan/isi-surat-klarifikasi',
    component: React.lazy(() => import('./suratKlarifikasi/suratKlarifikasi')),
  },
  {
    path: '/penanganan-uang-diragukan/overview-surat-klarifikasi',
    component: React.lazy(() =>
      import('./overViewKlarifikasi/overViewKlarifikasi'),
    ),
  },
  {
    path: '/penanganan-uang-diragukan/isi-surat-tanggapan',
    component: React.lazy(() => import('./suratTanggapan/suratTanggapan')),
  },
  {
    path: '/penanganan-uang-diragukan/overview-surat-tanggapan',
    component: React.lazy(() =>
      import('./overViewTanggapan/overViewTanggapan'),
    ),
  },
  {
    path: '/penanganan-uang-diragukan/detail',
    component: React.lazy(() => import('./detail/detail')),
  },
];
